import { render, staticRenderFns } from "./SortableTableArrows.vue?vue&type=template&id=05cd53ba&"
import script from "./SortableTableArrows.vue?vue&type=script&lang=js&"
export * from "./SortableTableArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports